import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { ACTIVE_SCHEMA_FIELDS } from '../basics';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/** Form schema for the DebitCardLoyaltyStatus component settings in the designer. */
export const DEBIT_CARD_LOYALTY_STATUS_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'showMoreInfos',
      label: 'components.debitCardLoyaltyStatus.schema.showMoreInfos',
      description: 'components.debitCardLoyaltyStatus.schema.showMoreInfosDescription',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'buttons',
      label: 'components.debitCardLoyaltyStatus.schema.buttons',
      type: 'group',
      expandable: true,
      default: {},
      fields: buttonSchemaFields()
    }
  ]
};
